<template>
	<div class="conversation-list-navbar navbar card">
		<div class="navbar-section"></div>
		<div class="navbar-section navbar-center">
			<span class="navbar-brand">ThunderWave X</span>
			<!-- <span v-if="oneProviderMode" class="navbar-brand2">&nbsp;{{ getAllConversationProviders[0].name }}</span> -->
		</div>
		<div class="navbar-section"></div>
	</div>
</template>

<script>
// import { mapGetters } from 'vuex';

export default {
	name: 'ConversationListNavbar',
	data() {
		return {};
	}
	// computed: {
	//     ...mapGetters({
	//         oneProviderMode: 'ConversationProviders/oneProviderMode',
	//         getAllConversationProviders: 'ConversationProviders/getAllConversationProviders'
	//     })
	// }
};
</script>
